import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import Drawer from '@mui/material/Drawer';
import DialogTitle from '@mui/material/DialogTitle';
import ModalClose from '@mui/icons-material/CloseRounded';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Tag } from 'primereact/tag'
import { Image } from 'primereact/image';
import ViewReportIcon from '../../../assets/images/icons/view-report.svg';
import DeleteReportIcon from '../../../assets/images/icons/delete-report.svg';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import { Box, Grid, Typography, FormGroup, TextField } from '@mui/material';
import EmailReports from '../reports/EmailReports';
import { Dropdown } from 'primereact/dropdown';
import { ApiData } from '../../../data/apiData';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import getRequest, { deleteRequest } from '../../../assets/helper/ApiHandler';
import { filterOptions } from '../../../assets/const/Constant';
import moment from 'moment';
import { formatDate } from '../../../assets/helper/dateFormatter';
import { ProgressSpinner } from 'primereact/progressspinner';
import { predefinedRanges } from '../../../assets/const/dateRanges';

var scheduleReportsObject = {
    "receiverEmail": null,
    "scheduleType": null,
    "timeStamp": null
}

export default function SavedReports() {
    const [componentToRender, setComponentToRender] = useState(null);
    const [savedReports, setSavedReports] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [report, setReport] = useState(null);
    const [rowClick, setRowClick] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const reportExport = useRef(null);
    const tableData = useRef(null);
    const toast = useRef(null);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [state, setState] = React.useState({ right: false, });
    const [visibleDeleteReport, setDeleteReportVisible] = useState(false);
    const [reportIdToBeDelete, setReportIdToBeDelete] = useState(null);
    const [scheduleReportIdToBeDeleted, setScheduleReportIdToBeDeleted] = useState(null);
    const navigate = useNavigate();
    const toastReportDeleted = useRef(null);
    const [scheduleReports, setScheduleReports] = useState([])
    const [reportRangeFormatted, setReportRangeFormatted] = useState(null);
    const [loading, setLoading] =useState();


    useEffect(() => {
        getSavedReport();
    }, [])

 

    const getFormattedDateRangeFromPredefined = (report) => {
        if (report && predefinedRanges[report.dateRange]) {
            const [startDate, endDate] = predefinedRanges[report.dateRange];
            return `${formatDate(startDate)} - ${formatDate(endDate)}`;
        }else{
            return `${formatDate(report?.startDate?? "")} - ${formatDate(report?.endDate??"")}`
        }
 };

    const getSavedReport = async () => {
        setLoading(true)
        try {
            const report = await getRequest(`/ui-report-filters`, null, navigate);
            setSavedReports(report);
            if(report.length>0) {
              setReport(report[0]);
        }
        else {
            setReport(null);
        }
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
        finally{
            setLoading(false);
        }
    }

    const deleteScheduleReport = async (id) => {
        setLoading(true);
        try {
            let res = await deleteRequest(`/schedule-reports/${id}`);
            if (res.status === 204) {
                toast.current.show({ severity: "success", summary: 'Success', detail: "Schedule Report deleted" });
                // setScheduleReports(scheduleReports.filter(report => report.id !== id));
                navigate('/schedule-reports'); 
            }
        } catch (error) {
            toast.current.show({ severity: "error", summary: 'Error', detail: error });
        }
        finally{
            setLoading(false);
        }
    }
   
    const handleOnClickReportName = (report, anchor) => {
        toggleDrawer(anchor, true)
        navigate('/reports/' + report.reportType, { state: { reportId: report.id, reportType:report.reportType } })
    }

    const reportNameColumn = (e) => {
        return (
            <div>
                {['right'].map((anchor) => (
                    <div className="supplyPartner flex" key={anchor} onClick={() => handleOnClickReportName(e, anchor)}>
                        {e?.reportName}
                    </div>
                ))}
            </div>
        )
    }

    const paginatorTemplate = {
        layout: 'RowsPerPageDropdown CurrentPageReport NextPageLink PrevPageLink',
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 5, value: 5 },
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 120, value: 120 }
            ];

            return (
                <React.Fragment>
                    <div className='paginatorLeft'>
                        <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                            Rows per page {' '}
                        </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return (
                <div className='paginatorRight'>
                    <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                        Pages {options.first} of {options.totalRecords}
                    </span>
                </div>
            );
        }
    };

    const toggleDrawer = (anchor, open, component) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setComponentToRender(component);
        setState({ ...state, [anchor]: open });
    };

    const headerDeleteReport = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Delete report</span>
        </div>
    );

    const footerDeleteReport = (
        <div>
            <Button label="Cancel" className='button-style-2' onClick={() => setDeleteReportVisible(false)} autoFocus />
            <Button label="Delete report" className='button-style-1' onClick={(e) => {
                handleDeleteReport();
                setDeleteReportVisible(false);
            }} autoFocus />
        </div>
    );



    const [visibleCancelScheduledReport, setCancelScheduledReportVisible] = useState(false);

    const headerCancelScheduled = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Cancel scheduled report</span>
        </div>
    );

    const footerCancelScheduled = (
        <div>
            <Button label="Cancel" className='button-style-2' onClick={() => setCancelScheduledReportVisible(false)} autoFocus />
            <Button label="Cancel scheduled report" className='button-style-1' onClick={(e) => { handleDeleteScheduleReport();setCancelScheduledReportVisible(false)}} autoFocus />
        </div>
    );

    const toastNewReportSaved = useRef(null);

    const showReportOnAction = (report) => {
        setReport(report);
    }


    const handleDeleteScheduleReport = async () => {
        setLoading(true)
        if (scheduleReportIdToBeDeleted) {
            try {
                await deleteRequest(`/schedule-reports/${scheduleReportIdToBeDeleted}`, null, navigate);
                toast.current.show({ severity: "success", summary: 'Success', detail: 'Schedule-Report has been successfully cancelled'  });
                setScheduleReportIdToBeDeleted(null);
            } catch (error) {
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
            finally{
                setLoading(false);
            }
        }
    }

    const checkScheduleReports = (reportId) => {
        return scheduleReports.some(scheduleReport => scheduleReport.report.id === reportId);
    };

    const handleDeleteReport = async () => {
        setLoading(true)
        if (reportIdToBeDelete) {

            if (checkScheduleReports(reportIdToBeDelete)) {
                toast.current.show({ severity: "error", summary: 'Error', detail: 'First delete all schedule reports' });
                return;
            }

            try {
                await deleteRequest(`/ui-report-filters/${reportIdToBeDelete}`, null, navigate);
                getSavedReport();
                setReportIdToBeDelete(null);
                toast.current.show({ severity: "success", summary: 'Success', detail: 'Report has been successfully deleted'  });

            } catch (error) {
                if(toast.current){
                    toast.current.show({ severity: "error", summary: 'Error', detail: error });
                }
            }
            finally{
                setLoading(false);
            }
            setDeleteReportVisible(false)
        }
    }
    const actionBtn = (e) => {
        return (
            <div className="actionBtn flex justify-content-center">
                <Button link onClick={() => showReportOnAction(e)}><Image src={ViewReportIcon} alt="Image" width="15" /></Button>
                <Button link onClick={() => { setReportIdToBeDelete(e?.id); setDeleteReportVisible(true) }}><Image src={DeleteReportIcon} alt="Image" width="15" /></Button>
            </div>
        );
    };


    const getFilter = () => {
        return report.filters && (
            Object.entries(JSON.parse(report.filters)).map(item => {
                if (item[0] !== "global") {
                    const key = item[0].toUpperCase();
                    const filterOption = filterOptions.find(option => option.value === item[1].matchMode);
                    const matchModeLabel = filterOption ? filterOption.label : item[1].matchMode;

                    return (
                        <h3 className='fs-16-600' key={key}>
                            {key} <span className='fs-16-400'>{matchModeLabel}</span> <span className='fs-16-400'>{item[1].value}</span>
                        </h3>
                    );
                }
                return null;
            })
        );
    }

    const formatTime = (time) => {
        if (typeof time !== 'number') return time;
        const hours = time % 12 || 12; // Convert 0-11 to 12AM-11AM and 12-23 to 12PM-11PM
        const period = time < 12 ? 'AM' : 'PM';
        const formattedTime = `${hours}:00 ${period}`;
        return formattedTime;
    };



    return (
        <div className="card saved-reports">
            <Toast ref={toast} position="bottom-right"></Toast>
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div" className='main-content-title'>
                    <h2 className='title'>Saved Reports </h2>
                </Typography>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            <Grid container spacing={0}>
                <Grid item xs={12} md={12} lg={12} className='header' sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                    <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end', padding: '1rem 0' }}>
                        <div className="flex justify-content-start">
                            <Link to='/reports' className='button-link-normal'>Back to Reports</Link>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} md={6} lg={6} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                { loading ? (
                <ProgressSpinner />
            ) : (
                    <DataTable
                        ref={tableData}
                        value={savedReports}
                        //filters={filters}
                        emptyMessage="No customers found."
                        selectionMode={rowClick ? null : 'checkbox'}
                        selection={selectedProducts}
                        onSelectionChange={(e) => setSelectedProducts(e.value)}
                        dataKey="id"
                        paginator rows={10}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginatorTemplate={paginatorTemplate}
                        tableStyle={{ minWidth: '5rem' }} resizableColumns>
                        <Column selectionMode="multiple" headerStyle={{ width: '1rem' }}></Column>
                        <Column field="reportName" body={reportNameColumn} header="Report Name" headerStyle={{ textAlign: 'center', width: '3rem' }}></Column>
                        <Column field="reportType" header="Report Type" headerStyle={{ textAlign: 'center', width: '3rem' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                        <Column field="supplierCPM" header="Supplier CPM" headerStyle={{ textAlign: 'center', width: '3rem' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                        <Column field="action" body={actionBtn} header="Action" headerStyle={{ textAlign: 'center', width: '2rem' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
                    </DataTable>
                    )}
                </Grid>

                {report && (
                    <Grid item xs={12} md={6} lg={6} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='saved-reports-details' >
                        <div className='saved-reports-content'>
                            <p className='fs-12-400'>Saved Report Name</p>
                            <h3 className='fs-16-600 brand-color'>{report.reportName}</h3>
                            <br></br>
                            <p className='fs-12-400'>Saved Report Type</p>
                            <h3 className='fs-16-600 brand-color'>{report.reportType}</h3>
                            <br></br>
                            <p className='fs-12-400'>Date Range</p>
                            <h3 className='fs-16-600'>{report.dateRange?? "Custom Range"}</h3>
                            <h3 className='fs-16-600'>{getFormattedDateRangeFromPredefined(report)}</h3>
                            <br></br>   
                            <p className='fs-12-400'>Filters</p>
                            {getFilter()}
                            <br></br>
                            <br></br>
                            {report?.scheduleReports?.length > 0 && (
                            <>
                            <p className='fs-12-400'>Scheduled  Reports</p>
                            <Grid container spacing={0} className='scheduled-reports-card'>
                                <Grid container spacing={2}>
                                { loading ? (
                <ProgressSpinner />
            ) : (   <>
                                    {report?.scheduleReports?.map((report, index) => (
                                        <Grid item xs={11} md={11} lg={11} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} key={index}>
                                            <div className='fs-16-600'><span className='brand-color'>Recipient:</span> {report.receiverEmail}</div>
                                            <div className='fs-16-600'><span className='brand-color'>Frequency:</span> {report.scheduleType}</div>
                                            <div className='fs-16-600'><span className='brand-color'>Time:</span> {formatTime(parseInt(report.timeStamp))}</div> {/* Ensure timeStamp is parsed as an integer */}
                                            <Grid item xs={1} md={1} lg={1} className="close-btn-wrapper" sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto', display: 'flex', }} >
                                                <IconButton size="sm" onClick={() => { setScheduleReportIdToBeDeleted(report.id);setCancelScheduledReportVisible(true)}} >
                                                    <CloseRoundedIcon className='close-btn' />
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    ))}
                                    </>
            )}
                                </Grid>
                            </Grid>
                            </>
                            )}
                        </div>
                    </Grid>
                )
                }
            </Grid>

            <Dialog className='sample-dialog'
                visible={visibleDeleteReport}
                modal
                header={headerDeleteReport}
                footer={footerDeleteReport}
                style={{ width: '360px' }}
                onHide={() => setDeleteReportVisible(false)}>
                <p className="fs-12-500">
                    You have chosen to delete this report. Once deleted, any users configured to receive this report as a scheduled report won’t receive it. Do you want to proceed?
                </p>
            </Dialog>
            <Dialog className='sample-dialog' visible={visibleCancelScheduledReport} modal header={headerCancelScheduled} footer={footerCancelScheduled} style={{ width: '360px' }} onHide={() => setCancelScheduledReportVisible(false)}>
                <p className="fs-12-500">
                    You have chosen to cancel this scheduled report. Once cancelled, the configured users will not receive this report. Do you want to proceed?
                </p>
            </Dialog>
            <Toast ref={toastReportDeleted} position="bottom-right" />
            <Toast ref={toastNewReportSaved} position="bottom-right" />

            {['right'].map((anchor) => (
                <Drawer key={anchor}
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}>
                    <Box className='drawerHeader'>
                        <DialogTitle >Schedule Reports</DialogTitle>
                        <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                    </Box>
                    {componentToRender === 'EmailReports' && <EmailReports />}
                </Drawer>
            ))}
        </div>

    )
}
